import {HStack} from 'platform/foundation';
import {useFormatCurrency} from 'platform/locale';

import {Flag} from '../../../../components/Flag/Flag';

interface PriceChartLabelProps {
  viewBox: {x: number; y: number};
  index: number;
  totalPoints: number;
  firstPrice: number;
  lastPrice: number;
  currency: string;
}

const LABEL_HEIGHT = 20;
const LABEL_WIDTH = 80;
const TOP_THRESHOLD = LABEL_HEIGHT + 4;
const HORIZONTAL_PADDING = 4;

export function PriceChartLabel(props: PriceChartLabelProps) {
  const formatCurrency = useFormatCurrency();

  const isFirstPoint = props.index === 0;
  const isLastPoint = props.index === props.totalPoints - 1;

  if (!isFirstPoint && !isLastPoint) {
    return null;
  }

  const labelValue = isFirstPoint ? props.firstPrice : props.lastPrice;
  const labelText = formatCurrency(labelValue, props.currency) ?? '';
  const xPosition = isFirstPoint
    ? props.viewBox.x + HORIZONTAL_PADDING
    : props.viewBox.x - LABEL_WIDTH - HORIZONTAL_PADDING;
  const isTooCloseToTop = props.viewBox.y < TOP_THRESHOLD;
  const yPosition = isTooCloseToTop ? props.viewBox.y + 4 : props.viewBox.y - LABEL_HEIGHT;

  return (
    <foreignObject
      x={xPosition}
      y={yPosition}
      height={LABEL_HEIGHT}
      width={LABEL_WIDTH}
      pointerEvents="none"
    >
      <HStack justify={isFirstPoint ? 'flex-start' : 'flex-end'}>
        <Flag
          label={labelText}
          size="small"
          backgroundColor="general.accent"
          color="general.white"
        />
      </HStack>
    </foreignObject>
  );
}
